export const parseSvgString = (svgString) => {
  const parser = new DOMParser();
  return parser.parseFromString(svgString, 'image/svg+xml');
};

export default { };
